import { render } from "./Footer.vue?vue&type=template&id=7dcd70ae&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=7dcd70ae&lang=scss&scoped=true"

import exportComponent from "D:\\workSpan\\vue\\billow-global-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dcd70ae"]])

export default __exports__